import {
	createBrowserRouter,
	Navigate,
	RouterProvider,
} from 'react-router-dom';

import { HelmetProvider } from 'react-helmet-async';

import { Home } from './home/Home';

import Drafts from '../../views/drafts/Drafts';
import config from '../../config';
import { IssueView } from '../../views/issue/Issue';
import { Logout } from './auth/Logout';

import { Preview } from '../../components/preview/Preview';

import { Callback } from './callback/Callback';
import { Subscriptions } from './subscriptions/Subscriptions';
import { Success } from './subscriptions/success/Success';
// import config from '../../config';

import './App.css';
import { useTrackingInstallion } from '../../tracking/Tracking.hooks';
import { useInterval } from '../../App.hooks';
import { tryRefreshToken, logOut, useRefreshOnBuild } from './auth/Auth.hooks';
import { IS_AUTHENTICATED_KEY } from '@/auth/constants';

function App() {
	const basename = config?.build?.subdirectory
		? config.build.subdirectory
		: undefined;
	useTrackingInstallion();
	// Remove comment to refresh build on logout
	useRefreshOnBuild();
	// const INTERVAL_TIME = 5 * 60 * 1000;
	const INTERVAL_TIME = 30 * 1000;
	useInterval(() => {
		tryRefreshToken('/', { minutes: 1 });
	}, INTERVAL_TIME);
	const onClickLogOut = localStorage.getItem(IS_AUTHENTICATED_KEY)
		? (url?: string): void => {
				console.log(`Click logout to the followin url: ${url}`);
				logOut(url || '/logout');
		  }
		: undefined;

	const routes = [
		{
			path: '/',
			element: <Home onClickLogOut={onClickLogOut} />,
		},
		{
			path: '/issues/:id',
			element: <IssueView onClickLogOut={onClickLogOut} />,
		},
		{
			path: '/issues/:id/:articleId',
			element: <IssueView onClickLogOut={onClickLogOut} />,
		},
		{
			path: '/preview/:id',
			element: <Preview />,
		},
		{
			path: '/subscriptions',
			element: <Subscriptions />,
		},
		{
			path: '/subscriptions/success',
			element: <Success />,
		},
		{
			path: '/callback',
			element: <Callback />,
		},
		{
			path: '/logout',
			element: <Logout />,
		},
	];

	if (config?.app?.admin) {
		routes.push({
			path: '/drafts',
			element: <Drafts />,
		});
	}

	routes.push({
		path: '*',
		element: <Navigate to="/" replace />,
	});

	const router = createBrowserRouter(routes, {
		basename,
	});

	const classNames = ['App'];

	return (
		<HelmetProvider>
			<div className={classNames.join(' ')}>
				<RouterProvider router={router} />
			</div>
		</HelmetProvider>
	);
}

export default App;
